import React, { memo } from 'react';
import { AIAssistantButton } from './AIAssistantButton';
import { AIAssistantOverlay } from './overlay';

export const AIAssistant = memo(function AIAssistant() {
  return (
    <>
      <AIAssistantButton />
      <AIAssistantOverlay />
    </>
  );
});
